export default __webpack_public_path__ + "static/media/bg-conclusao.180e39d5.png";